import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Input
} from '@angular/core';

import { Subscription } from 'rxjs/Subscription';

export interface PagePartnerInterface {
  logo: {
    url: string,
    width: number
  };
  image: {
    url: string,
    subtitle: string
  };
  content: string;
  link: string;
  person: {
    image: string,
    name: string,
    description: string
  };
}

@Component({
  styleUrls: ['./partner.component.scss'],
  templateUrl: './partner.component.html'
})
export class PagePartnerComponent implements OnInit {
  @Input()
  public stateParams: {
    partner: PagePartnerInterface
  };

  public partner: PagePartnerInterface;

  public ngOnInit() {
    this.partner = this.stateParams.partner;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/partner/partner.component.ts